













































































































import Breadcrumb from '@/components/Breadcrumb.vue';
import Component, {mixins} from 'vue-class-component';
import AXIOS from '@/services/axios-wrapper';
import GeneralUtil from '@/util/GeneralUtil';
import {namespace} from 'vuex-class';
import {User} from '@/models';
import {PMS_Res_Trouble} from '@/models-trouble';
const Auth = namespace('Auth');

@Component({
  components: {
    GeneralUtil,
    Breadcrumb,
  },
})
export default class ManagementTrouble extends GeneralUtil {
  @Auth.Getter
  public loginUser!: User;

  @Auth.Getter
  public isLoggedIn!: boolean;

  @Auth.Getter
  public selectedNumberMember!: number;

  reservinfo_breadcrumb = {
    toplink: 'HOME',
    prevlink: 'Management',
    present: '수선접수현황',
  };
  isBusy = false;
  v_datepicker_masks = {
    input: 'YYYY-MM-DD',
  };
  fields = [
    {
      key: 'troubleNo',
      label: '번호',
    },
    {
      key: 'troubleMemo',
      label: '내용',
    },
    {
      key: 'regDate',
      label: '등록일자',
    },
    {
      key: 'startDate',
      label: '시작일자',
    },
    {
      key: 'endDate',
      label: '종료일자',
    },
    {
      key: 'troubleStatus',
      label: '처리여부',
    },
    {
      key: 'show_details',
      label: '처리내용',
    },
  ];
  troubleList: PMS_Res_Trouble[] = [
    {
      troubleNo: '1',
      troubleMemo: '접수내용입니다',
      regDate: '2000-11-2',
      startDate: '2002-22-3',
      endDate: '2002-11-3',
      troubleStatus: '미처리',
      responseText: '처리완료',
    },
  ];
  troubleRegMemo = '';
  MAX_LENGTH_MEMO = 50;
  resetModal() {
    this.troubleRegMemo = '';
  }
  async handleOk(bvModalEvent: any) {
    // Prevent modal from closing
    bvModalEvent.preventDefault();
    // Trigger submit handler
    if (this.troubleRegMemo.trim() === '') {
      this.showMsgBoxOk('등록할 내용을 입력하세요');
      return;
    }
    return this.regTroble(this.troubleRegMemo);
  }
  async regTroble(troubleMemo: string) {
    console.log(troubleMemo);
  }
  changeTroubleRegMemo(changedText: string) {
    console.log(changedText);
    if (changedText!.length > this.MAX_LENGTH_MEMO) {
      this.troubleRegMemo = changedText.substr(0, this.MAX_LENGTH_MEMO);
    }
  }
  openModalTroubleReg() {
    this.$bvModal.show('modal-reg-trouble');
  }
  // mounted() {
  //   this.$store.dispatch('Display/changeName', {name: '예약안내'});
  // },
}
